import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Lookup, LookupSubmit, LookupVerbose, TableListFieldOption, TableListFieldOptionSubmit, TableListFieldOptionVerbose } from '../../models/lookup.model';
import { LookupService } from '../../services/lookup.service';
import moment from 'moment';
import { finalize } from 'rxjs/operators';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CultureService } from '@app/core/services/system-language/culture.service';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { LocalizationFormService } from '@app/shared/services/localization-form.service';

@Component({
  selector: 'app-edit-lookup-dialog',
  templateUrl: './edit-lookup-dialog.component.html',
  styleUrls: ['./edit-lookup-dialog.component.scss']
})
export class EditLookupDialogComponent implements OnInit {
  listGroup: string;
  listOptionId: string;
  tableListFieldOption: TableListFieldOptionVerbose;
  form: UntypedFormGroup;
  loading: boolean = true;
  cultures: Culture[];

  constructor(
    private snackbarService: SnackbarService,
    private fb: UntypedFormBuilder,
    private localizationFormService: LocalizationFormService,
    private lookupService: LookupService,
    private overlayService: OverlayService,
    private cultureService: CultureService,
    private dialogRef: MatDialogRef<EditLookupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.listGroup = data.listGroup;
      this.listOptionId = data.listOptionId;
    }

  ngOnInit(): void {
    this.cultureService.getCultures().subscribe( res => { this.cultures = res } );
    this.getLookupData();
  }

  getLookupData() {
    this.loading = true;

    this.lookupService.getTableListFieldOption(this.listGroup, this.listOptionId)
    .pipe(
      finalize(() => this.loading = false)
    )
    .subscribe(
      res => {
        this.tableListFieldOption = res;
        this.createForm();
      },
      err => {

      }
    )
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.tableListFieldOption.id],
      asOf: [moment().format()],
      text: this.localizationFormService.buildLocalizationArray(this.tableListFieldOption.text),
      endDate: [this.tableListFieldOption.endDate],
      startDate: [this.tableListFieldOption.startDate],
      prioritize: [this.tableListFieldOption.prioritize, Validators.required]
    });
  }

  get localizations() {
    return this.form.controls["text"] as UntypedFormArray;
  }

  addNewLocalization(culture?: string, text?: string) {
    this.localizations.push(this.localizationFormService.createLocalizationGroup(culture, text));
  }

  deleteLocalization(index: number) {
    this.localizations.removeAt(index);
  }

  save() {
    let tableListFieldOptionSubmit: TableListFieldOptionSubmit = {
      asOf: moment().format(),
      changeReason: '',
      changeReasonComments: '',
      id: this.form.value.id,
      prioritize: this.form.value.prioritize,
      startDate: this.form.value.startDate,
      endDate: this.form.value.endDate,
      text: []
    }

    this.form.value.text.forEach(localization => {
      tableListFieldOptionSubmit.text.push(localization);
    });

    this.overlayService.show();

    this.lookupService.updateTableListFieldOption(this.listGroup, this.tableListFieldOption.id, tableListFieldOptionSubmit)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.dialogRef.close(true);
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  close() {
    this.dialogRef.close();
  }

}
